import * as React from "react";
import { connect } from "react-redux";
import LocationQueue from "../presentation/LocationQueue";
import { UserInfo } from "../../../Login/common/defaults";
import { showLoadingWithMessage } from "../../../Application/redux-objects/actions";
import { assignWorkflowItem } from "../../redux-objects/actions";
import { updateHeaderByComponent } from "../../../Navigation/redux-objects/actions";
import { view } from "../../DataTranscriberValidation/redux-objects/actions";
import { IWorkflowItemStep } from "../../../../common/sharedTypes";
import LocationQueuePaged from "../presentation/LocationQueuePaged";

interface ILocationQueueControllerOwnProps {
  history: any;
  location: any;
  match: any;
  queueToLoad: eLocationQueue;
}

interface ILocationQueueControllerPropsFromState {
  webServiceURL: string;
  currentUser: UserInfo;
  workflowStepsLoading: boolean;
}

interface ILocationQueueControllerActions {
  showLoadingWithMessage: (show: boolean, message?: string) => void;
  assignWorkflowItem: (url: string, stepItemId: number, assignToId: number) => Promise<any>;
  updateHeaderByComponent: (headerInfo: string) => void;
}

export enum eLocationQueue {
  SpotMapping,
  LocationReview,
}

type ILocationQueueControllerProps = ILocationQueueControllerOwnProps &
  ILocationQueueControllerPropsFromState &
  ILocationQueueControllerActions;

export class QueueController extends React.Component<ILocationQueueControllerProps> {
  constructor(props) {
    super(props);
  }

  componentDidUpdate() {
    this.props.showLoadingWithMessage(
      this.props.workflowStepsLoading,
      "Loading Queue Information ..."
    );
  }

  render() {
    return (
      <React.Fragment>
        {!this.props.workflowStepsLoading && (
          <LocationQueuePaged
            endPoint={this.props.webServiceURL}
            currentUser={this.props.currentUser}
            history={this.props.history}
            queueToShow={this.props.queueToLoad}
            assignWorkflowItem={this.props.assignWorkflowItem}
            updateHeaderOnNav={this.props.updateHeaderByComponent}
          />
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = (reduxState: any) => {
  return {
    webServiceURL: reduxState.Application.backendURL,
    currentUser: reduxState.Application.currentUser,
    workflowStepsLoading: reduxState.WorkflowQueues.WorkFlowStepsLoading,
  };
};

const mapDispatchToProps = {
  showLoadingWithMessage,
  assignWorkflowItem,
  updateHeaderByComponent,
  view,
};

export default connect<ILocationQueueControllerPropsFromState, ILocationQueueControllerActions>(
  mapStateToProps,
  mapDispatchToProps,
  null,
  { forwardRef: true }
)(QueueController);
